import { Component } from "react";



class About extends Component {
    render() { 
        return (
            <section className="about padding-top padding-bottom">
                <div className="container">
                    <div className="about__wrapper">
                        <div className="row g-5 align-items-center">
                            <div className="col-lg-6">
                                <div className="about__thumb" data-aos="fade-right" data-aos-duration="1000">
                                    <img src="assets/images/art/01.gif" alt="About Image" />
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="about__content" data-aos="fade-left" data-aos-duration="1000">
                                    <h2>7777 Unique NFT Penqueens</h2>
                                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Vo luptas de leniti voluptatibus officia! Ipsum porro repellendu quis fuga illooxe in officia consectetur adipisicing elitRe.</p>
                                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Vo luptas de leniti voluptatibus officia! Ipsum porro repellendu quis fuga illooxe in officia consectetur adipisicing elitRe.</p>
                                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Vo luptas de leniti voluptatibus officia! Ipsum porro repellendu quis fuga illooxe in officia consectetur adipisicing elitRe.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}
 
export default About;